import type { ReactNode } from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { clsx } from 'clsx';
import { Icon } from '@ics-portal/guardian';
import { useGlobalUI } from '@contexts/GlobalUiContext';
import useMaintenanceData from '@hooks/useMaintenenceInfo';
import useUserEventsSubscription from '@hooks/useUserEventsSubscription';
import Sidebar from './components/_organisms/sidebar/Sidebar';
import EnvironmentBanner from './components/EnvironmentBanner';
import s from './app.module.scss';

export default function App(): ReactNode {
    const { appClassName, appSidebarHidden } = useGlobalUI();
    const maintenanceData = useMaintenanceData();
    useUserEventsSubscription();

    const classes = clsx(s.container, {
        [s.hidden]: appSidebarHidden,
        [s.collapsed]: appClassName === 'collapsed',
    });

    return (
        <>
            {maintenanceData?.message ? (
                <div className={s.maintenance}>
                    <Icon fontSize="normal" name="info" />
                    <h3>{maintenanceData.message}</h3>
                </div>
            ) : null}
            <div className={classes}>
                <main id="app-main" className={s.main}>
                    <Suspense fallback={<span>Loading..</span>}>
                        <Outlet />
                    </Suspense>
                </main>
                <aside className={s.aside}>
                    <EnvironmentBanner />
                    <Sidebar />
                </aside>
            </div>
        </>
    );
}
